import Helper from "./Helper";
import "./E1.css";

export default function E1(){
    return (
            <div style={{width: '30em', height: '30em'}}>
                 <Helper style={{position: 'relative'}} />
            </div>
           
    );

}